export default function DashboardContent(props: { children: React.ReactNode }) {
  return <div className="px-6">{props.children}</div>
}
